// extracted by mini-css-extract-plugin
module.exports = {"cardmsgB":"cardmsgB_cardmsgB__eemZw"};